import { render, staticRenderFns } from "./GoodsSet.vue?vue&type=template&id=723931a6&scoped=true"
import script from "./GoodsSet.vue?vue&type=script&lang=js"
export * from "./GoodsSet.vue?vue&type=script&lang=js"
import style0 from "./GoodsSet.vue?vue&type=style&index=0&id=723931a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723931a6",
  null
  
)

export default component.exports